import { render, staticRenderFns } from "./ChallengeSelector.vue?vue&type=template&id=6fd0d750"
import script from "./ChallengeSelector.vue?vue&type=script&lang=js"
export * from "./ChallengeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports